import { FastlyImage } from '@components/common/image'

const STATS = [
  {
    label: 'Average monthly:',
    highlight: 'INR 46,000',
  },
  {
    label: 'Highest monthly:',
    highlight: 'INR 1,85,000',
  },
  {
    highlight: 'INR 17Cr',
    label: 'paid out last year',
    highlightFirst: true,
  },
]

const TeachingPaysGrows = () => (
  <div className="px-5 py-12 lg:py-16 bg-blue-50 bg-opacity-25">
    <div className="container mx-auto pb-4 md:pb-0">
      <h2 className="max-w-4xl mx-auto text-2xl text-center text-grey lg:text-4xl font-600 p-1 px-3">
        Teaching that pays and grows
      </h2>
      <p className="font-400 text-lg md:text-xl text-center max-w-3xl mx-auto mt-8 px-3">
        Educators on Codingal teach on their terms. Whether teaching full-time
        or a few hours a week, earnings grow with consistency and performance.
      </p>

      <div className="flex flex-col md:flex-row items-center gap-8">
        <div className="flex-1 flex justify-center">
          <FastlyImage
            src="/images/teacher-lp/firstFold/hero.png"
            alt="Teacher at desk with laptop"
            height="550"
            width="800"
            className="w-full max-w-md"
          />
        </div>

        <ul className="flex-1 flex flex-col gap-6">
          {STATS.map((stat) => (
            <li
              key={stat.highlight}
              className="text-lg md:text-xl font-600 text-grey-900"
            >
              {stat.highlightFirst ? (
                <>
                  <span className="text-blue-200">{stat.highlight}</span>{' '}
                  {stat.label}
                </>
              ) : (
                <>
                  {stat.label}{' '}
                  <span className="text-blue-200">{stat.highlight}</span>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
)

export default TeachingPaysGrows
